import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/LinkIcon";

export const AuthorityManagementContent = () => {
  const { t } = useTranslation();
  return (
    <div className="authority-management-content">
      <div className="inner">
        <div className="feature-item">
          <div className="feature-content">
            <div className="title">
              {t("learn.authority.features.item1.title")}
            </div>
            <div className="item-warp">
              <div className="descript">
                {t("learn.authority.features.item1.descript")}
              </div>
            </div>
            <div className="item-warp">
              <div className="sub-title">
                {t("learn.authority.features.item1.sub.title")}
              </div>
              <div className="descript">
                {t("learn.authority.features.item1.sub.descript")}
              </div>
            </div>
            <Link
              href="https://docs.authing.cn/v2/guides/access-control/choose-the-right-access-control-model.html#%E4%BB%80%E4%B9%88%E6%98%AF%E5%9F%BA%E4%BA%8E%E5%B1%9E%E6%80%A7%E7%9A%84%E8%AE%BF%E9%97%AE%E6%8E%A7%E5%88%B6-abac"
              target="_blank"
            >
              {t("learn.common.check-doc")}
            </Link>
          </div>
          <div className="feature-img">
            <img
              src="http://files.authing.co/authing-website/authority-management-rbac.png"
              alt="权限管理访问管理"
            />
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-img">
            <img
              src={`http://files.authing.co/authing-website/authority-management-abac.png`}
              alt="权限管理数据访问"
            />
          </div>
          <div className="feature-content">
            <div className="title">
              {t("learn.authority.features.item2.title")}
            </div>
            <div className="item-warp">
              <div className="descript">
                {t("learn.authority.features.item2.descript")}
              </div>
            </div>
            <div className="item-warp">
              <div className="sub-title">
                {t("learn.authority.features.item2.sub.title")}
              </div>
              <div className="descript">
                {t("learn.authority.features.item2.sub.list1")}
              </div>
            </div>
            <div className="item-warp">
              <div className="descript">
                {t("learn.authority.features.item2.sub.list2")}
              </div>
              <div className="descript">
                {t("learn.authority.features.item2.sub.list3")}
              </div>
              <div className="descript">
                {t("learn.authority.features.item2.sub.list4")}
              </div>
            </div>
            <div className="item-warp">
              <div className="descript">
                {t("learn.authority.features.item2.sub.descript")}
              </div>
            </div>
            <Link
              href="https://docs.authing.cn/v2/guides/access-control/choose-the-right-access-control-model.html#%E4%BB%80%E4%B9%88%E6%98%AF%E5%9F%BA%E4%BA%8E%E8%A7%92%E8%89%B2%E7%9A%84%E8%AE%BF%E9%97%AE%E6%8E%A7%E5%88%B6-rbac"
              target="_blank"
            >
              {t("learn.common.check-doc")}
            </Link>
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-content">
            <div className="title">
              {t("learn.authority.features.item3.title")}
            </div>
            <div className="item-warp">
              <div className="descript">
                {t("learn.authority.features.item3.descript1")}
              </div>
            </div>
            <div className="item-warp">
              <div className="descript">
                {t("learn.authority.features.item3.descript2")}
              </div>
            </div>
          </div>
          <div className="feature-img">
            <img
              src="http://files.authing.co/authing-website/authority-management-model.png"
              alt="角色权限管理系统"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
